import { render } from "./DialogConfirmResetSelectedSeat.vue?vue&type=template&id=a05c43b0"
import script from "./DialogConfirmResetSelectedSeat.vue?vue&type=script&lang=js"
export * from "./DialogConfirmResetSelectedSeat.vue?vue&type=script&lang=js"
script.render = render

export default script